import React from 'react';

const helpbusinessDetails = [
  {
    businessImg: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/help_your_business/credit_assessment.svg`,
    businessTitle: "Actionable Data Insights",
    businessInfo: "Analyze business data and insights to make informed decisions"
  },
  {
    businessImg: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/help_your_business/data_insights.svg`,
    businessTitle: "Total Credit Assessment",
    businessInfo: "Extensive coverage of the data points important to make credit decisions"
  },
  {
    businessImg: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/help_your_business/risk_monitoring.svg`,
    businessTitle: "Continuous Risk Monitoring",
    businessInfo: "Analyze business data and insights to make informed decisions"
  },
  {
    businessImg: `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/help_your_business/cost_complexity.svg`,
    businessTitle: "Reduce Cost and Complexity",
    businessInfo: "Reduce revenue leakages by conducting trade with complaint business"
  }
]
const HelpYourBusiness = () => {
  return (
    <div>
      <h2 className="buisnessTitle text-center ff-renner-bold">
        How can Crediwatch help your business?
      </h2>
      <div className='d-flex align-items-center justify-content-center'>
        <div className='line text-primary bg-primary mt-4' />
      </div>
      <div className='row mt-4 justify-content-center'>
        {helpbusinessDetails.map((each) => {
          return (
            <div className="col-lg-3 col-md-4 col-12 mt-4 p-3">
              <div className='custom-card d-flex align-items-center justify-content-center flex-column p-2 h-100'>
                <div className='blue-circle'>
                  <div className='h-100 w-100 d-flex align-items-center justify-content-center'>
                    <img src={each.businessImg}
                      className='attachment-full size-full'
                      alt='cost-complexity'
                      loading='lazy'
                      height='82px'
                      width='82px' />
                  </div>
                </div>
                <h5 className='mt-4 ff-renner-book text-center help-business-width w-25'>{each.businessTitle} </h5>
                <h6 className='mt-4 ff-renner-book text-center help-business-width'>{each.businessInfo}</h6>
              </div>
            </div>
          );
        })
        }
      </div>

    </div>
  );
}
export default HelpYourBusiness;